import { validate } from 'vee-validate';
import moment from 'moment';
import { Event, LogFilter, Utils, ErrorHandler } from './assets/js';
import API from './libs/coms/';
import countries from './countries';
import Session from './libs/session';
import notifications from './libs/notifications';
import Vue from 'vue';

export default class Packages {
	constructor(Vue) {
		global.moment = moment;
		this.initializeLocalAssets();

		setTimeout(async () => {
			this.notifications();
			this.session();
			this.remoteComs();
			this.validator();
			this.clarks();
		});
	}

	notifications() {
		global.$notify = notifications.notify;
	}

	initializeLocalAssets() {
		new LogFilter();
		// global.Event = new Event(new this.vue())
		global.Event = new Vue();
		global.utils = new Utils();
		global.errHandler = new ErrorHandler();
	}

	validator() {
		const rules = require('./libs/validator/rules');
		global.validate = validate;
	}

	session() {
		global.$session = new Session();
	}

	remoteComs() {
		global.api = new API();
	}

	fetchCountries() {
		return new Promise(async (resolve, reject) => {
			try {
				$session.set('countries', countries);
			} catch (error) {
				reject(error);
			}
		});
	}

	async clarks() {
		await this.fetchCountries();
	}
}
